<div class="modal-header">
	<h4 class="modal-title fw-bold">
		@if (modeView === ModeView.VIEW) {
			<span jhiTranslate="ontology-manager.tab.scales.modal.detail.header"></span>
		} @else if (modeView === ModeView.EDIT) {
			<span jhiTranslate="ontology-manager.tab.scales.modal.edit.header"></span>
		} @else if (modeView === ModeView.CREATE) {
			<span jhiTranslate="ontology-manager.tab.scales.modal.create.header"></span>
		}
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal"
			(click)="clear()">
	</button>
</div>
<div class="modal-body">
	<div class="row" *ngIf="showNoEditableFieldAlert() && !showNoneEditableCategoriesAlert()">
		<div class="col">
			<div class="alert alert-warning" role="alert">
				<i class="fa fa-warning pe-2"></i>
				<span jhiTranslate="ontology-manager.validation.scale.noneditableFields"></span>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="showNoneEditableCategoriesAlert()">
		<div class="col">
			<div class="alert alert-warning" role="alert">
				<i class="fa fa-warning pe-2"></i>
				<span jhiTranslate="ontology-manager.validation.categories.noneditableCategories"></span>
			</div>
		</div>
	</div>
	<form name="form" #f="ngForm">
		<div class="mb-3 row">
			<label for="scaleName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.name">Name</label>
			<div class="col-sm-9">
				<jhi-input
					name="scaleName"
					[property]="'name'"
					[model]="scaleDetails"
					[modeView]="modeView"
					[disabled]="isLoading"
					[required]="true"
					[maxLength]="NAME_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="scaleDetails.name"
					#scaleName="ngModel">
				</jhi-input>
				@if ((f.submitted || scaleName.touched) && scaleName.errors?.required) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.name.required' | translate }}</div>
				} @else if ((f.submitted || scaleName.dirty) && scaleName.errors?.maxlength) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: NAME_TEXT_LIMIT } }}</div>
				} @else if ((f.submitted || scaleName.dirty) && scaleName.errors?.pattern) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.name.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
				}
			</div>
		</div>
		<div class="mb-3 row">
			<label for="description" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.description">Description</label>
			<div class="col-sm-9">
				<jhi-textarea
					name="description"
					[modeView]="modeView"
					[model]="scaleDetails"
					[property]="'description'"
					[disabled]="isLoading"
					[required]="false"
					[maxLength]="DESCRIPTION_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="scaleDetails.description"
					#description="ngModel">
				</jhi-textarea>
				@if ((f.submitted || description.dirty) && description.errors?.maxlength) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: DESCRIPTION_TEXT_LIMIT } }}</div>
				} @else if ((f.submitted || description.dirty) && description.errors?.pattern) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.description.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
				}

			</div>
		</div>
		<div class="mb-3 row">
			<label for="dataType" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.data-type">Data Type</label>
			<div class="col-sm-9">
				<jhi-select
					name="dataType"
					[modeView]="modeView"
					[model]="scaleDetails"
					[options]="dataTypes"
					[required]="true"
					[property]="'dataType'"
					[returnType]="'object'"
					[disabled]="isLoading"
					[labelField]="'name'"
					[idField]="'id'"
					[(ngModel)]="scaleDetails.dataType"
					(ngModelChange)="onDataTypeChanged($event)"
					#dataTypeCtrl="ngModel">
				</jhi-select>
			</div>
		</div>
		<div *ngIf="showRangeWidget">
			<div class="mb-3 row">
				<label for="type" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.valid-range">Valid Range</label>
				<div class="col-sm-9">
					<jhi-numeric-range name="numericRange"
									   [modeView]="modeView"
									   [model]="scaleDetails"
									   [property]="'validValues'"
									   [numeric]="showRangeWidget"
									   [min]="MIN_RANGE"
									   [max]="MAX_RANGE"
									   [disabled]="isLoading"
									   [(ngModel)]="scaleDetails.validValues"
									   #numericRange="ngModel">
					</jhi-numeric-range>
					@if (f.submitted || numericRange.dirty) {
						@if (numericRange.errors?.minTooBig) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.min.too.big' | translate }}
							</div>
						} @else if (numericRange.errors?.minOutOfRange) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.min.out.of.range' | translate }}
							</div>
						} @else if (numericRange.errors?.maxOutOfRange) {
							<div class="text-danger pt-2">
								{{ 'ontology-manager.validation.numeric.range.max.out.of.range' | translate }}
							</div>
						}
					}
				</div>
			</div>
		</div>
		<div *ngIf="showCategoricalWidget">
			<div class="mb-3 row">
				<label for="scaleDescription" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.scales.modal.scale.categories">Categories</label>
				<div class="col-sm-9">
					<jhi-categories
						name="omCategories"
						[modeView]="modeView"
						[model]="scaleDetails"
						[property]="'validValues'"
						[pattern]="SPECIAL_CHARACTERS"
						[(ngModel)]="scaleDetails.validValues.categories"
						#omCategories="ngModel">
					</jhi-categories>
					@if ((f.submitted || omCategories.touched) && omCategories.errors?.emptyValue) {
						<div class="text-danger pt-2">
							{{ 'ontology-manager.validation.categories.emptyvalue' | translate }}
						</div>
					} @else if ((f.submitted || omCategories.dirty) && omCategories.errors?.nonUniqueName) {
						<div class="text-danger pt-2">
							{{ 'ontology-manager.validation.categories.nonUniqueName' | translate }}
						</div>
					} @else if ((f.submitted || omCategories.dirty) && omCategories.errors?.nonUniqueValue) {
						<div class="text-danger pt-2">
							{{ 'ontology-manager.validation.categories.nonUniqueValue' | translate }}
						</div>
					} @else if ((f.submitted || omCategories.dirty) && omCategories.errors?.pattern) {
						<div class="text-danger pt-2">
							{{ 'ontology-manager.validation.category.fields.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}
						</div>
					}
				</div>
			</div>
		</div>
	</form>
	<br>
	<jhi-metadata [modeView]="modeView" [metadata]="scaleDetails.metadata" [extendedUsage]="false"></jhi-metadata>
</div>
<div class="modal-footer">
	@if (modeView === ModeView.EDIT || modeView === ModeView.CREATE) {
		<button type="button" class="btn btn-secondary" (click)="discard()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="discard"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			@if (modeView === ModeView.EDIT) {
				<span jhiTranslate="update"></span>
			} @else {
				<span jhiTranslate="create"></span>
			}
		</button>
	} @else {
		<button type="button" class="btn btn-secondary" (click)="clear()">
			<span jhiTranslate="back"></span>
		</button>
		@if (isDeletable()) {
			<button type="button" class="btn btn-info me-2" (click)="delete()">
				<span class="fa fa-trash"></span>&nbsp;<span jhiTranslate="delete"></span>
			</button>
		}
		<button type="button" class="btn btn-outline-info" (click)="edit()">
			<span class="fa fa-pencil"></span>&nbsp;<span jhiTranslate="edit"></span>
		</button>
	}
</div>
